"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataSet = void 0;
exports.DataSet = {
  name: 'DataSet',
  autoRoutes: ['create', 'update', 'list'],
  list: {
    resultsVariant: 'list'
  },
  select: {
    queryFields: "\n      description { id text plain }\n    "
  }
};